import { CityLocationDetailPage } from "@/components/locations/CityLocationDetailPage";
import {
  ANTALYA_DESTINATIONS,
  antalyaDestinationPath,
  antalyaHubPath,
  resolveAntalyaDestination,
} from "@/data/antalyaLocations";

const AntalyaLocationDetail = () => (
  <CityLocationDetailPage
    citySlug="antalya"
    destinations={ANTALYA_DESTINATIONS}
    destinationPath={antalyaDestinationPath}
    hubPath={antalyaHubPath}
    resolveDestination={resolveAntalyaDestination}
  />
);

export default AntalyaLocationDetail;
